import { render, staticRenderFns } from "./CyberboardTerminal.vue?vue&type=template&id=a4e64806&scoped=true"
import script from "./CyberboardTerminal.vue?vue&type=script&lang=ts"
export * from "./CyberboardTerminal.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardTerminal.vue?vue&type=style&index=0&id=a4e64806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e64806",
  null
  
)

export default component.exports